import { useCallback } from 'react';

import { fetchAggResponse } from '../../../../../common/fetch/fetch-agg-response';

import {
	UPDATE_BOOKMARK_OPERATION_NAME,
	UpdateBookmarkMutation,
} from './UpdateBookmarkMutation.graphql';

type UpdateBookmarkVariables = {
	orgId: string;
	cloudId: string;
	keyPhrases: string[];
	url: string;
	title: string;
	description: string;
	bookmarkAdminhubId: string;
};

type BookmarkError = {
	message?: string;
	extensions?: object;
};

type Bookmark = {
	id: string;
	properties: {
		title: string;
		description?: string;
		keyPhrases: string[];
		url: string;
	};
};

type UpdateBookmarkData = {
	knowledgeDiscovery: {
		updateBookmark?: {
			success: boolean;
			errors?: BookmarkError[];
			adminhubBookmark?: Bookmark;
		};
	};
};

export const useUpdateBookmarkMutation = () => {
	const updateBookmark = useCallback(async (variables: UpdateBookmarkVariables) => {
		return fetchAggResponse<UpdateBookmarkVariables, UpdateBookmarkData>({
			graphQuery: UpdateBookmarkMutation,
			variables,
			operationName: UPDATE_BOOKMARK_OPERATION_NAME,
		}).then((response) => {
			const updateBookmarkResponse = response?.data?.knowledgeDiscovery.updateBookmark;

			if (updateBookmarkResponse) {
				return {
					success: updateBookmarkResponse.success,
					errors: updateBookmarkResponse.errors || [],
					adminhubBookmark: updateBookmarkResponse.adminhubBookmark,
				};
			} else {
				throw new Error('updateBookmark mutation unsuccessful');
			}
		});
	}, []);

	return {
		updateBookmark,
	};
};
